// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-bar[data-v-38b700f7]{text-align:right !important}.left-text[data-v-38b700f7]{left:2em;position:absolute}.total-text[data-v-38b700f7]{font-size:.9rem;vertical-align:center}.description-text[data-v-38b700f7]{white-space:initial}@media(max-width: 991.98px){.left-text[data-v-38b700f7]{left:8px;position:absolute}.description-text[data-v-38b700f7]{font-size:12px;line-height:1.3;text-align:left}.text-block[data-v-38b700f7]{display:block}}", ""]);
// Exports
module.exports = exports;
